export default "__VITE_ASSET__C2ka7zjR__"